<div class="sc-dialog" [class.minimized]="isMinimized"
     cdkDrag cdkDragRootElement=".cdk-overlay-pane">

  <!-- Header (asa de arrastre) -->
  <div class="sc-header" cdkDragHandle>
    <h2 class="sc-title" [title]="'Sincronizar posiciones de Cartera Control Operativa ' + data.optimalWallet.nombre + ' vs Cartera suscrita'">
      <mat-icon>sync_alt</mat-icon>
      <span class="sc-title-text">Sincronizar posiciones de Cartera Control Operativa {{ data.optimalWallet.nombre }} vs Cartera suscrita</span>
    </h2>
    <div class="sc-header-actions">
      <button mat-icon-button class="help-button" (click)="mostrarAyuda = !mostrarAyuda"
              [class.active]="mostrarAyuda" matTooltip="¿Cómo funciona la sincronización?"
              aria-label="Ayuda" [style.display]="isMinimized ? 'none' : ''">
        <mat-icon>help_outline</mat-icon>
      </button>
      <button mat-icon-button class="close-button" (click)="toggleMinimize()"
              [matTooltip]="isMinimized ? 'Restaurar' : 'Minimizar'"
              [attr.aria-label]="isMinimized ? 'Restaurar' : 'Minimizar'">
        <mat-icon>{{ isMinimized ? 'open_in_full' : 'remove' }}</mat-icon>
      </button>
      <button mat-icon-button class="close-button" (click)="cerrar()" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Content -->
  <div class="sc-content">

    <div *ngIf="mostrarAyuda" class="sc-help">
      <mat-icon class="sc-help-icon">info_outline</mat-icon>
      <div class="sc-help-body">
        <p>
          Sincronizar revisa el/los modelo(s) desde la fecha de suscripción y lo compara contra la
          cartera actual del broker.
        </p>
        <ul>
          <li>Muestra las operaciones en las que se <b>debería entrar</b> para tener sincronía con las
            posiciones en cartera del modelo.</li>
          <li>Muestra las operaciones de las que se <b>debería salir</b> para tener sincronía con las
            posiciones en cartera del modelo.</li>
        </ul>
        <p class="sc-help-note">
          La comparación se hace contra Diversificador / Modelo, porque ahí es donde se generan las
          operaciones y la cartera desde la fecha de suscripción.
        </p>
      </div>
    </div>

    <div *ngIf="loadingSuscripciones" class="sc-loading">
      <mat-spinner diameter="28"></mat-spinner>
      <span>Consultando suscripciones...</span>
    </div>

    <div *ngIf="errorMsg" class="alert alert-warning">{{ errorMsg }}</div>

    <div *ngIf="automatizacionActiva" class="alert alert-warning">
      La automatización de esta cartera está activa. Deténgala en la pestaña "Automatizado" para poder
      sincronizar y evitar envíos duplicados.
    </div>

    <div *ngIf="!automatizacionActiva" class="alert alert-info">
      Las operaciones sincronizadas se enviarán al broker de inmediato, sin necesidad de reactivar la automatización.
    </div>

    <div *ngIf="sinParametrosRiesgo && selectedIdModelo !== TODOS_ID" class="alert alert-warning">
      No se pudieron obtener los parámetros de riesgo de la cartera óptima para esta subcartera, por lo
      que no es posible calcular un tamaño de posición seguro. Las operaciones faltantes se muestran de
      solo lectura (no seleccionables) hasta resolverlo.
    </div>

    <div *ngIf="algunasSinParametrosRiesgo" class="alert alert-warning">
      Algunas subcarteras no tienen parámetros de riesgo configurados, por lo que no es posible calcular
      un tamaño de posición seguro para ellas. Sus operaciones faltantes se muestran de solo lectura (no
      seleccionables) hasta resolverlo.
    </div>

    <div class="sc-toolbar">
      
      <div class="sc-toolbar-right">
        <div *ngIf="subcartOptions.length > 0" class="sc-subcart-selector">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" floatLabel="always">
            <mat-label>Vista</mat-label>
            <mat-select [value]="selectedIdModelo" (selectionChange)="seleccionarSubcart($event.value)">
              <mat-option *ngFor="let opt of subcartOptions" [value]="opt.idModelo">
                {{ opt.nombre }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div *ngIf="infoSuscripcion" class="sc-suscripcion-info">
          <span *ngIf="infoSuscripcion.nombre" class="sc-info-nombre">{{ infoSuscripcion.nombre }}</span>
          <span *ngIf="infoSuscripcion.fecha" class="sc-info-item">Suscrita: {{ infoSuscripcion.fecha }}</span>
          <span *ngFor="let m of infoSuscripcion.modelos" class="sc-info-item"
                [class.trend-down]="m.bajista" [class.trend-up]="!m.bajista"
                [matTooltip]="m.bajista ? 'Bajista' : 'Alcista'"><ng-container *ngIf="m.nombre">{{ m.nombre }} · </ng-container>{{ m.periodo }} {{ m.bajista ? '↓' : '↑' }}</span>
        </div>
        <button mat-flat-button color="primary" (click)="sincronizarSeleccionadas()"
                [disabled]="cargandoComparativa || comparisonRows.length === 0 || automatizacionActiva"
                [matTooltip]="automatizacionActiva ? 'Detenga la automatización de esta cartera primero' : ''">
          Sincronizar
        </button>

      </div>
      <span *ngIf="selection.selected.length > 0" class="sc-selected-count">
        {{ selection.selected.length }} seleccionada(s)
      </span>
    </div>

    <div *ngIf="selectedIdModelo && cargandoComparativa" class="sc-loading">
      <mat-spinner diameter="28"></mat-spinner>
      <span>Calculando comparativa de operaciones...</span>
    </div>

    <div *ngIf="selectedIdModelo && !cargandoComparativa && comparisonRows.length > 0"
         class="sc-table-wrapper wrapper2 tableStyle">
      <table cdk-table [dataSource]="comparisonRows" matSort (matSortChange)="sortData($event)"
             class="table-striped tableStyle">

        <ng-container cdkColumnDef="contador">
          <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">#</th>
          <td cdk-cell *cdkCellDef="let row; let i = index">{{ i + 1 }}</td>
        </ng-container>

        <ng-container cdkColumnDef="select">
          <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">
            <mat-checkbox (change)="toggleAll()" [checked]="isAllSelectableSelected()"></mat-checkbox>
          </th>
          <td cdk-cell *cdkCellDef="let row">
            <mat-checkbox *ngIf="esSeleccionable(row)" (click)="$event.stopPropagation()"
                          (change)="toggleRow(row)" [checked]="selection.isSelected(row)"></mat-checkbox>
            <span *ngIf="row.missing && !esSeleccionable(row)" class="sc-badge sc-badge-missing"
                  [matTooltip]="tooltipNoSeleccionable(row)">N/D</span>
          </td>
        </ng-container>

        <ng-container cdkColumnDef="subcartera">
          <th cdk-header-cell *cdkHeaderCellDef mat-sort-header class="sticky-header">Subcartera</th>
          <td cdk-cell *cdkCellDef="let row">{{ nombreSubcartera(row.idmodelo) }}</td>
        </ng-container>

        <ng-container cdkColumnDef="isooper">
          <th cdk-header-cell *cdkHeaderCellDef mat-sort-header class="sticky-header">ID</th>
          <td cdk-cell *cdkCellDef="let row">{{ row.isooper }}<ng-container *ngIf="row.reentradaIsooper"> → {{ row.reentradaIsooper }}</ng-container></td>
        </ng-container>

        <ng-container cdkColumnDef="nombreCompania">
          <th cdk-header-cell *cdkHeaderCellDef mat-sort-header class="sticky-header">Compañía</th>
          <td cdk-cell *cdkCellDef="let row">{{ row.nombreCompania }}</td>
        </ng-container>

        <ng-container cdkColumnDef="tipoOperacion">
          <th cdk-header-cell *cdkHeaderCellDef mat-sort-header class="sticky-header">Tipo</th>
          <td cdk-cell *cdkCellDef="let row"
              [ngClass]="{'salida': tipoOperacionDisplay(row).startsWith('SALIDA'), 'entrada': tipoOperacionDisplay(row).startsWith('ENTRADA')}">
            {{ tipoOperacionDisplay(row) }}
          </td>
        </ng-container>

        <ng-container cdkColumnDef="fechaOperacion">
          <th cdk-header-cell *cdkHeaderCellDef mat-sort-header class="sticky-header">Fecha</th>
          <td cdk-cell *cdkCellDef="let row">{{ row.fechaOperacion | smartDate }} {{ horaDeFila(row) }}</td>
        </ng-container>

        <ng-container cdkColumnDef="precioentradareal">
          <th cdk-header-cell *cdkHeaderCellDef mat-sort-header class="sticky-header">Entrada</th>
          <td cdk-cell *cdkCellDef="let row">{{ row.precioentradareal }}</td>
        </ng-container>

        <ng-container cdkColumnDef="preciosalidareal">
          <th cdk-header-cell *cdkHeaderCellDef mat-sort-header class="sticky-header">Salida</th>
          <td cdk-cell *cdkCellDef="let row">{{ row.preciosalidareal }}</td>
        </ng-container>

        <ng-container cdkColumnDef="stoploss">
          <th cdk-header-cell *cdkHeaderCellDef mat-sort-header class="sticky-header">Stop Loss</th>
          <td cdk-cell *cdkCellDef="let row">{{ row.stoploss | number:(row.secType === 'CFD' ? '1.5-5' : '1.2-2') }}</td>
        </ng-container>

        <ng-container cdkColumnDef="profit">
          <th cdk-header-cell *cdkHeaderCellDef mat-sort-header class="sticky-header">Profit</th>
          <td cdk-cell *cdkCellDef="let row">{{ row.profit | number:(row.secType === 'CFD' ? '1.5-5' : '1.2-2') }}</td>
        </ng-container>

        <ng-container cdkColumnDef="cantidadacciones">
          <th cdk-header-cell *cdkHeaderCellDef mat-sort-header class="sticky-header">N° Acciones</th>
          <td cdk-cell *cdkCellDef="let row">{{ row.cantidadacciones | number:'1.2-2' }}</td>
        </ng-container>

        <ng-container cdkColumnDef="beneficioperdida">
          <th cdk-header-cell *cdkHeaderCellDef mat-sort-header class="sticky-header">Beneficio</th>
          <td cdk-cell *cdkCellDef="let row"
              [ngClass]="{'numero-positivo': row.beneficioperdida > 0, 'numero-negativo': row.beneficioperdida < 0}">
            {{ row.beneficioperdida }}
          </td>
        </ng-container>

        <ng-container cdkColumnDef="origen">
          <th cdk-header-cell *cdkHeaderCellDef mat-sort-header class="sticky-header">Estado</th>
          <td cdk-cell *cdkCellDef="let row">
            <span *ngIf="row.pendienteBarra" class="sc-badge sc-badge-warn"
                  [matTooltip]="tooltipReentrada(row)">Cerrada por {{ row.cierreBroker?.tipo }} en el broker</span>
            <span *ngIf="row.reentrada && !row.pendienteBarra" class="sc-badge sc-badge-warn"
                  [matTooltip]="tooltipReentrada(row)">Reentrada (ya cerrada)</span>
            <span *ngIf="row.missing && !row.reentrada" class="sc-badge sc-badge-missing">No sincronizado</span>
            <span *ngIf="!row.missing" class="sc-badge sc-badge-ok">Sincronizado</span>
          </td>
        </ng-container>

        <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
        <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"
            [class.selected]="selection.isSelected(row)"
            [class.sc-row-missing]="row.missing"></tr>
      </table>
    </div>

    <div *ngIf="selectedIdModelo && !cargandoComparativa && comparisonRows.length === 0 && !errorMsg"
         class="alert alert-info">
      La cartera está sincronizada: no hay operaciones pendientes.
    </div>

  </div>
</div>
